import { render, staticRenderFns } from "./KkmSetCanChangePublicKey.vue?vue&type=template&id=71a37c3a&"
import script from "./KkmSetCanChangePublicKey.vue?vue&type=script&lang=js&"
export * from "./KkmSetCanChangePublicKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports